import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const schema = () => {
  const { t } = useTranslation('signInAddress');
  return yup.object().shape({
    zip: yup
      .string()
      .required(t('create_account_invalid_zip'))
      .min(5, t('create_account_invalid_less_min'))
      .matches(/^[0-9]+$/, t('create_account_invalid_zip_number')),
    address: yup.string().required(t('create_account_invalid_address')),
    complement: yup.string().notRequired(),
    city: yup.string().required(t('create_account_invalid_city')),
    state: yup.string().required(t('create_account_invalid_state')),
  });
};
